import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  Row,
  Col,
  Layout,
  Avatar,
  Dropdown,
  Menu,
  Image,
  Space,
  Button,
  Typography,
  MenuProps,
} from "antd";
import {
  UserOutlined,
  LogoutOutlined,
  ContactsOutlined,
} from "@ant-design/icons";
import { deleteCookie } from "../../../utils/helper";
import Logo from "../../../assets/img/ACL.svg";
import SubMenu from "antd/es/menu/SubMenu";
import { useEnv } from "../../../configs/constants";
import { setSelectedCompany } from "../../modules/Calendar/ducks/actions";
import { useSelector } from "react-redux";

const { Header } = Layout;
const { Text } = Typography;

const HeaderBar = () => {
  const dispatch: any = useDispatch();
  const navigate = useNavigate();
  const [companyCodes, setCompanyCodes] = useState([]);
  const [companyCode, setCompany] = useState(
    JSON.parse(window.localStorage.getItem("Selected-Company-Code"))
  );
  const selectedCompany = useSelector(
    (state: any) => state.calendar.selectedCompany
  );

  const items: MenuProps["items"] =
    companyCodes?.length > 0
      ? companyCodes?.map((code) => ({ key: code, label: code }))
      : [];

  const logoutHandler = async () => {
    localStorage.clear();
    deleteCookie("carsTaxiUser");
    deleteCookie("idToken", `/${useEnv.env}/carstaxi/portal`);
    sessionStorage.removeItem("afterLoginRoute");
    // navigate('/login');
    window.location.href = "/login";
    // }
  };

  function parseJsonString(str) {
    try {
      let parsed = JSON.parse(str);
      if (typeof parsed === "string") parsed = JSON.parse(parsed);
      return parsed;
    } catch (error) {
      console.error("Error parsing JSON string:", error);
      return null;
    }
  }

  useEffect(() => {
    const fetchCompanyCodes = async () => {
      const codes = parseJsonString(
        window.localStorage.getItem("companyCodes")
      );
      // console.log("CODES----->",codes);
      if (codes && codes?.length > 0) {
        setCompanyCodes(codes);
        if (!companyCode || !selectedCompany) {
          // if company code is not already selected | default to first code
          setCompany(codes[0]);
          dispatch(setSelectedCompany(codes[0]));
        }
      }
    };

    setTimeout(() => {
      fetchCompanyCodes();
    }, 3000);
  }, []);

  const menu = (
    <Menu>
      {/* <SubMenu key='Maintenance' icon={<ContactsOutlined />} title='Contact Us'>
        <Menu.Item key='getHelp'>
          <Link to={'/contactus'} state={{ type: 'Get help' }}>
            Get help
          </Link>
        </Menu.Item>
        <Menu.Item key='reportProblem'>
          <Link to={'/contactus'} state={{ type: 'Report a problem' }}>
            Report a problem
          </Link>
        </Menu.Item>
        <Menu.Item key='requestFeature'>
          <Link to={'/contactus'} state={{ type: 'Request a feature' }}>
            Request a feature
          </Link>
        </Menu.Item>
        <Menu.Item key='requestDeactivation'>
          <Link to={'/contactus'} state={{ type: 'Request deactivation' }}>
            Request deactivation
          </Link>
        </Menu.Item>
      </SubMenu> */}

      <Menu.Item>
        <Button
          onClick={logoutHandler}
          type="link"
          className="btn-link"
          icon={<LogoutOutlined />}
        >
          &nbsp; Logout
        </Button>
      </Menu.Item>
    </Menu>
  );

  const handleCompanySelect: MenuProps["onClick"] = (code) => {
    setCompany(code?.key);
    dispatch(setSelectedCompany(code?.key));
    // dispatch(setCompanyCodes(code));
    // setCompany(code);
    // dispatch(fetchProviders(code?.key));
    // dispatch(setSelectedProvider(null));
  };

  return (
    <Header className="site-header">
      <Row>
        <Col flex={200}>
          <Image
            src={Logo}
            preview={false}
            width={150}
            alt="logo"
            style={{ marginTop: 20 }}
          />
        </Col>
        <Col
          flex="auto"
          style={{
            justifyContent: "center",
            alignItems: "center",
            display: "flex",
          }}
        >
          <Space size={12}>
            {items?.length > 0 && (
              <Dropdown
                menu={{
                  items,
                  onClick: handleCompanySelect,
                  selectable: true,
                  defaultSelectedKeys: [companyCode],
                }}
                placement="bottomRight"
                trigger={["click"]}
              >
                <Button type="link">
                  {companyCode || "Select Company"}{" "}
                  <span style={{ marginLeft: "5px" }}>▼</span>
                </Button>
              </Dropdown>
            )}

            <Dropdown overlay={menu} placement="bottomRight">
              <Space>
                <Avatar
                  size={24}
                  icon={<UserOutlined />}
                  style={{ backgroundColor: "#016130", color: "#fff" }}
                />
                <Text>
                  {JSON.parse(window.localStorage.getItem("login-response"))
                    ?.name ||
                    JSON.parse(window.localStorage.getItem("sso-user"))?.name}
                </Text>
              </Space>
            </Dropdown>
          </Space>
        </Col>
      </Row>
    </Header>
  );
};

export default HeaderBar;
